<script>
import DatePicker from 'vue-datepicker-next';

// A vue-datepicker-next documenta TRÊS eventos para a mesma coisa: `change`
// (legado, "same as input"), `update:value` (o de Vue 3) e `confirm` (clique
// no botão, quando `confirm` está ligado). Escutar só `change` deixou o filtro
// do Relatório de Pipeline sem efeito: a tela pedia sempre a janela padrão.
// Aqui os três entram e saem como um único `change` para quem usa, sem
// repetir e sem deixar passar intervalo pela metade.
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    lang: {
      type: Object,
      default: undefined,
    },
  },
  emits: ['change'],
  data() {
    return { ultimoIntervalo: null };
  },
  methods: {
    // Enquanto a pessoa escolhe, a lib emite o intervalo pela metade
    // ([início, null]); mandar isso adiante viraria filtro com data inválida.
    intervaloCompleto(value) {
      return (
        Array.isArray(value) &&
        value.length === 2 &&
        value.every(
          data => data instanceof Date && !Number.isNaN(data.getTime())
        )
      );
    },
    handleChange(value) {
      if (!this.intervaloCompleto(value)) return;

      const assinatura = value.map(data => data.getTime()).join('|');
      if (assinatura === this.ultimoIntervalo) return;

      this.ultimoIntervalo = assinatura;
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      range
      confirm
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :lang="lang"
      @change="handleChange"
      @update:value="handleChange"
      @confirm="handleChange"
    />
  </div>
</template>
